import * as types from './mutation-types'

export default {
  [types.ADD_LOTS](state, data) {
    state.lots = data.lots
  },
  [types.ADD_LOT] (state, data) {
    state.lots.push(data)
  },
}
